import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiClientConfig } from '../api-client-config';
import { EMPTY, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeleteEntityServiceInterface } from '../interface/delete-entity-service-interface';
import { CreateResponse } from 'it/primatoo/openapi/api/common/schemas/CreateResponse';
import { ListUserColumnsResponse } from 'it/primatoo/openapi/api/org/schemas/common/ListUserColumnsResponse';
import { ListUserGroupResponse } from 'it/primatoo/openapi/api/org/schemas/usergroup/ListUserGroupResponse';
import { CreateUserGroupRequest } from 'it/primatoo/openapi/api/org/schemas/usergroup/CreateUserGroupRequest';
import { UpsertUserColumnRequest } from 'it/primatoo/openapi/api/org/schemas/common/UpsertUserColumnRequest';
import { UserGroup } from 'it/primatoo/openapi/api/org/schemas/usergroup/UserGroup';
import { UpdateUserGroupRequest } from 'it/primatoo/openapi/api/org/schemas/usergroup/UpdateUserGroupRequest';
import { ColumnWithLocalization } from 'it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization';

@Injectable({
  providedIn: 'root'
})
export class UserGroupsService implements DeleteEntityServiceInterface {
  private readonly endpointV2: string;

  constructor(
    @Inject(ApiClientConfig) private config: ApiClientConfig,
    public httpClient: HttpClient
  ) {
    this.endpointV2 = this.config.endPoint + '/api/org/v2/user-groups/';
  }

  public findUserGroupsColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpointV2 + 'columns/';
    return this.httpClient.get<ListUserColumnsResponse>(url).pipe(map(c => c.columns));
  }


  public findAllUserGroup(): Observable<ListUserGroupResponse> {
    const url = this.endpointV2;
    return this.httpClient.get<ListUserGroupResponse>(url);
  }

  public createUserGroup(user: CreateUserGroupRequest): Observable<CreateResponse> {
    const url = this.endpointV2;
    return this.httpClient.post<CreateResponse>(url, user);
  }


  public updateUserColumns(columnsConfigurationUpsertRequest: UpsertUserColumnRequest): Observable<void> {
    const url = this.endpointV2 + 'user-columns';
    return this.httpClient.post<void>(url, columnsConfigurationUpsertRequest);
  }


  public findById(id: number): Observable<UserGroup> {
    const url = this.endpointV2 + id + '/';
    return this.httpClient.get<UserGroup>(url);
  }

  public updateUserGroups(id: number, request: UpdateUserGroupRequest): Observable<void> {
    const url = this.endpointV2 + `${id}/`;
    return this.httpClient.put<void>(url, request);
  }


  public delete(id: number): Observable<void> {
    const url = this.endpointV2 + `${id}/`;
    return this.httpClient.delete<void>(url);
  }


  public deleteMultiple(ids: number[]): Observable<{ failed: number[] }> {
    return EMPTY;
  }

  public getDocDependencies(id: number): Observable<any> {
    return EMPTY;
  }

}
